export const endpoints = {
  users: "users",
  providers: "oauth2/providers",
  logout: "oauth2/logout",
};
